var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconModalAsset(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0v9h32V0H0Zm29.333 6.75H2.667v-4.5h26.666v4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 5h1v1H5zM8 5h1v1H8zM13 5h1v1h-1zM0 22h32v-9H0v9Zm2.667-6.75h26.666v4.5H2.667v-4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 16h1v1H5zM8 16h1v1H8zM13 16h1v1h-1zM17.333 24h-2.666v5.333H0V32h32v-2.667H17.333z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconModalAsset);
export default __webpack_public_path__ + "static/media/icon_modal_asset.b77e9819eebbae140144e3d94c9a71ce.svg";
export { ForwardRef as ReactComponent };